/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { NumberTypeDirective } from '@gh/core-type';
import { AbstractGridInputCellEditorComponent } from './abstract-grid-input-cell-editor.component';

@Component({
  standalone: false,
  selector: 'gh-grid-number-cell-editor',
  templateUrl: 'grid-number-cell-editor.component.html',
  styleUrls: ['grid-input-cell-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridNumberCellEditorComponent extends AbstractGridInputCellEditorComponent implements AfterViewInit {
  @ViewChild(NumberTypeDirective, { static: false }) numberTypeDir: NumberTypeDirective;

  isFormatOnFocus: boolean = true;

  private firstChar?: string;

  ngAfterViewInit(): void {
    if (this.firstChar) {
      this.numberTypeDir.input(this.firstChar);
    }
    super.ngAfterViewInit();
  }

  // we redefine setting of first character,
  // because for number input we want to have unmodified user input (possibly incomplete) on init.
  protected setFirstChar(char: string): void {
    this.firstChar = char;
    this.isFormatOnFocus = false;
  }
}
